import dayjs from 'dayjs';
require("dayjs/locale/th");
const buddhistEra = require('dayjs/plugin/buddhistEra')
dayjs.extend(buddhistEra)

export { dayjs }